import React, {useEffect,Suspense} from 'react';
import { Box, Button, Typography } from '@mui/material';
import logo from '../assets/img/DaVoiANoi2(trasp).png'
import { useTranslation } from 'react-i18next';
import Swal from "sweetalert2";  
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import LanguageSwitcher from '../components/LanguageSwitcher';
const Homepage = () => {
  const { t} = useTranslation();
  const navigate = useNavigate();
  const handleAlert = (title,message,type) => {
    Swal.fire({  
      title: title,  
      icon: type,  
      text: message,  
    });  
  }

  const location = useLocation();
  useEffect(() => {
    if (location.state?.success) {
    navigate(location.pathname, { success: false });
    }
  }, [location.state?.success, navigate]);

  const successMessage = location.state?.success


   

    const handleSuccess = () => {
      handleAlert(t("Questionario inviato!"),t("La tua opinione è importante per noi, grazie!"),'success');
    }
    const handleStart = () => {
      window.location.href = '/questionario';
    }
  return (
    <div style={{marginLeft:'1.5rem',marginRight:'1.5rem'}}>
    
    <LanguageSwitcher />
    <Suspense fallback="loading">
          {successMessage && handleSuccess()}

        <Box
      sx={{
        height: '90vh',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',

      }}
    >
      <img
        src={logo}
        alt="Logo"
        style={{ width: 350, marginBottom: 30,marginTop: 70 }}
      />
      <Typography variant="h4" component="h1" align="center" mb={4} >
        {t('Breve Questionario sulla qualità percepita')}
      </Typography>

      <Button variant="contained" size="large" onClick={handleStart} sx={{backgroundImage: 'linear-gradient(90deg, #137EC3, #0C5482)',fontWeight:"bold",height:70,fontSize:18}}>
      {t('Inizia Questionario')}
      </Button>


          <Typography variant="subtitle2" component="p" align="center" mt={4} fontStyle="italic" sx={{fontSize:16}}>
          {t('La valutazione riguarda una singola area di prestazioni per compilazione.')}

          </Typography>
          <Typography variant="subtitle2" component="p" align="center" mt={1} fontStyle="italic" >
          {t('Il questionario è anonimo e non verranno raccolti dati personali.')}
      </Typography>
          
    </Box>
          <Box sx={{height:'4vh'}}>
          <Typography variant="body1" component="p" align="center" mt={4} pb={2} fontStyle="italic">
          {t('La Sua Opinione ci aiuterà a rendere il servizio MIGLIORE')}
          </Typography>
          </Box>
          </Suspense>
    </div>

  );
};

export default Homepage;